import React from "react";
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";

const MIN_SKU = 1000000000000; // minimum 13 digits number
const MAX_SKU = 9999999999999; // max 13 digits number

// TODO: MIRAR ESTO CON DETENIMIENTO 
const withValueLimit = (inputObj) => {
  const { value } = inputObj;
  if (
    value.length < 13 ||
    (value.length === 13 && value < MAX_SKU && value > MIN_SKU)
  )
    return inputObj;
};

export default function SKUFormatter(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isNumericString
      isAllowed={withValueLimit}
    />
  );
}

SKUFormatter.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
